/*******************************************************************************
    plik  : frontend/src/main.tsx
    autor : Michal Kolodziejski (2:480/112.10)
    data  : 2025.01.06
    copyright  : PTODT <https://ptodt.org.pl>

    opis  : React application entry point

    licencja : MIT
*******************************************************************************/

import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import './styles/main.css';

/**
 * @brief Application root renderer
 */
ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
        <BrowserRouter>
            <App />
        </BrowserRouter>
    </React.StrictMode>
);
